import { attachMountScenarioToWindow } from '@busyrooms/vue-commons/entries/attach_global'

import type { IStaticConfiguration, PredefinedClientConfiguration, ScenarioParams } from './types'

/**
 * The Federated entrypoint for the IBE.
 * It will attach the `mountScenario` function to `window.BusyRooms` when in browser context,
 * and will also return it.
 * @param staticConfiguration Precompiled template configuration to apply (comes from Federated Host).
 *    This has the same schema for all templates and provides api keys, etc.
 * @param predefinedClientConfig Precompiled client configuration (also from Federated Host).
 *    This is for template-specific configurations, can be rewritten from outside.
 */
export default async function defaultEntry (
  staticConfiguration: IStaticConfiguration,
  predefinedClientConfig: PredefinedClientConfiguration
) {
  const templateMountScenario = (await import('./default.bootstrap')).default

  function mountScenario (params: ScenarioParams) {
    return templateMountScenario(staticConfiguration, {
      ...predefinedClientConfig,
      ...params
    })
  }

  // Standard attachment to `window`
  attachMountScenarioToWindow(mountScenario)

  // Return function as well (ease of consumption)
  return mountScenario
}
